// fontfaceobserver_init.js

// https://github.com/filamentgroup/font-loading/blob/master/font-events.html
// https://www.filamentgroup.com/lab/font-events.html

/*
Fonts are loaded through @font-face rules
in the CSS whenever an element references them.
FontFaceObserver creates a referencing element to trigger the font request,
and lsisten for font load events.
When all fonts are loaded,
we enable them by adding a class to the html element
*/
(function( w ) {
  // if the class is already set, we're good.

  if ( w.document.documentElement.className.indexOf( 'fonts-loaded' ) > -1 ) {
    return;
  }

  var fontA = new w.FontFaceObserver( 'alternate-gothic-no-2', {
    weight: 400,
  });

  /*
  fontA.load().then(function () {
    console.log('fontA is available');
  }, function () {
    console.log('fontA is not available');
  });
  */

  //

  var fontB = new w.FontFaceObserver( 'antennacond-bold', {
    weight: 700,
  });

  /*
  fontB.load().then(function () {
    console.log('fontB is available');
  }, function () {
    console.log('fontB is not available');
  });
  */

  //

  var fontC = new w.FontFaceObserver( 'antennacond-medium', {
    weight: 500,
  });


  /*
  fontC.load().then(function () {
    console.log('fontC is available');
  }, function () {
    console.log('fontC is not available');
  });
  */

  //

  var fontD = new w.FontFaceObserver( 'antennacond-regular', {
    weight: 400,
  });

  /*
  fontD.load().then(function () {
    console.log('fontD is available');
  }, function () {
    console.log('fontD is not available');
  });
  */

  //

  var fontE = new w.FontFaceObserver( 'antennacond-light', {
    weight: 300,
  });

  /*
  fontE.load().then(function () {
    console.log('fontE is available');
  }, function () {
    console.log('fontE is not available');
  });
  */

  //

  var fontF = new w.FontFaceObserver( 'antennacond-bold-italic', {
    weight: 700,
  });

  /*
  fontF.load().then(function () {
    console.log('fontF is available');
  }, function () {
    console.log('fontF is not available');
  });
  */

  //

  var fontG = new w.FontFaceObserver( 'antennacond-medium-italic', {
    weight: 500,
  });


  /*
  fontG.load().then(function () {
    console.log('fontG is available');
  }, function () {
    console.log('fontG is not available');
  });
  */

  //

  var fontH = new w.FontFaceObserver( 'antennacond-regular-italic', {
    weight: 400,
  });


  /*
  fontH.load().then(function () {
    console.log('fontH is available');
  }, function () {
    console.log('fontH is not available');
  });
  */

  //

  var fontI = new w.FontFaceObserver( 'antennacond-light-italic', {
    weight: 300,
  });

  // fontI.load().then(function() {
  //   console.log('fontI is available');
  // }, function() {
  //   console.log('fontI is not available');
  // });

  var fontJ = new w.FontFaceObserver( 'iconfont', {
    weight: 400,
  });

  // fontJ.load().then(function() {
  //   console.log('fontJ is available');
  // }, function() {
  //   console.log('fontJ is not available');
  // });

  /* eslint-disable */
  w.Promise
  .all([
    fontA.load(),
    fontB.load(),
    fontC.load(),
    fontD.load(),
    fontE.load(),
    fontF.load(),
    fontG.load(),
    fontH.load(),
    fontI.load(),
    fontJ.load(),
  ])
  .then(function() {
    w.document.documentElement.className += ' fonts-loaded';
  });
}( this ));

/* eslint-enable */

//
// EOF
//
